"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectedShippingMethod = exports.getRawSelectedShippingMethod = exports.getShippingMethods = exports.getShippingMethodsObject = void 0;
var reselect_1 = require("reselect");
var checkoutSelectors_1 = require("../checkoutSelectors");
var reducer_1 = require("./reducer");
var defaultShippingMethodsObj = {};
exports.getShippingMethodsObject = (0, reselect_1.createSelector)(checkoutSelectors_1.getCheckout, function (checkout) {
    return checkout.shippingMethods || defaultShippingMethodsObj;
});
exports.getShippingMethods = (0, reselect_1.createSelector)(exports.getShippingMethodsObject, function (shippingMethodsObject) {
    return shippingMethodsObject.methods || reducer_1.initialState.methods;
});
exports.getRawSelectedShippingMethod = (0, reselect_1.createSelector)(exports.getShippingMethodsObject, function (shippingMethodsObject) {
    return shippingMethodsObject.selected || '';
});
exports.getSelectedShippingMethod = (0, reselect_1.createSelector)(exports.getShippingMethods, exports.getRawSelectedShippingMethod, function (shippingMethods, rawSelectedMethod) {
    var _a;
    if (rawSelectedMethod) {
        return rawSelectedMethod;
    }
    return ((_a = shippingMethods === null || shippingMethods === void 0 ? void 0 : shippingMethods[0]) === null || _a === void 0 ? void 0 : _a.key) || '';
});
